module.exports = "/_next/static/images/DeliverUnifiedCustomerExperiences@2x-cac6244e237393b7671f5e24c0963c1e.png";